import { Component, OnInit } from '@angular/core';
import { FormListTableConfig } from "./forms-list.table-config";
import { BrokerAdminService, FormService, SurveyService } from '@app/services';
import { ApiResponse } from '@app/interfaces';
import { Route, Router } from '@angular/router';
import { APP_ROUTES } from '@app/constants';
@Component({
  selector: 'app-forms-list',
  templateUrl: './forms-list.component.html',
  styleUrls: ['./forms-list.component.scss']
})
export class FormsListComponent implements OnInit {

  config: any;
  isLoading: boolean = false;
  dataSource: any = []
  editSelected: any;

  constructor(
    private formService: FormService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.config = FormListTableConfig.configure();
    this.getList();
  }

  getList() {
    this.isLoading = true;
    this.formService.list().subscribe({
      next: (res: any) => {
        this.isLoading = false;
        this.dataSource = res.data
      }
    })
  }

  action(e: any) {
    this.editSelected = null;
    if (e.button.eventName == "edit") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER], {
        queryParams: { formId: e.data._id }
      });
    }
    if (e.button.eventName == "add") {
      this.router.navigate([APP_ROUTES.FORM_BUILDER]);
    }
  }

}
